import { Link } from 'react-router';
import { brand } from '@/config/brand';
import { useI18n } from '@/i18n/context';

export function BrandMark({ to = '/' }: { to?: string }) {
  const { locale } = useI18n();
  return (
    <Link to={to} className="inline-flex items-center gap-2 rounded-xl font-black text-brand-800">
      <img src="/favicon.svg" alt="" className="size-9" width={36} height={36} />
      <span className="text-xl">{brand.name[locale]}</span>
    </Link>
  );
}
